module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-checkbox-group', {
    staticClass: "z-list",
    on: {
      "change": _vm.emitCheck
    },
    model: {
      value: (_vm.ids),
      callback: function($$v) {
        _vm.ids = $$v
      },
      expression: "ids"
    }
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', [_vm._v(_vm._s(_vm.title_name))]), _vm._v(" "), _c('div', [_vm._v("任务编号")]), _vm._v(" "), (_vm.keyStatus == 10) ? _c('div', [_vm._v("创建时间")]) : _c('div', [_vm._v("发布时间")]), _vm._v(" "), _c('div', [_vm._v("任务名称")]), _vm._v(" "), _c('div', {
    staticClass: "more"
  }, [_vm._v("\n            任务类型\n            "), _c('span', {
    staticClass: "change"
  }), _vm._v(" "), _c('typeChoose', {
    staticClass: "show",
    attrs: {
      "length": _vm.taskTpl.length + 1
    }
  }, [_c('div', {
    staticClass: "active",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectType('', '全部类型', $event)
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.taskTpl), function(type, index) {
    return _c('div', {
      key: type.id,
      staticClass: "overhide",
      attrs: {
        "title": type.tpl_name
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.selectType(type.id, type.tpl_name, $event)
        }
      }
    }, [_vm._v(_vm._s(type.tpl_name))])
  })], 2)], 1), _vm._v(" "), _c('div', [_vm._v("任务奖金(" + _vm._s(_vm.task_curr.currency_name) + ")")]), _vm._v(" "), _c('div', [_vm._v("周期(天)")]), _vm._v(" "), _c('div', {
    staticClass: "more"
  }, [_vm._v("\n            状态\n            "), _c('span', {
    staticClass: "change"
  }), _vm._v(" "), _c('typeChoose', {
    staticClass: "show",
    attrs: {
      "length": Object.keys(_vm.status_obj).length + 1
    }
  }, [_c('div', {
    staticClass: "active",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectState('', '全部状态', $event)
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.status_obj), function(text, key) {
    return _c('div', {
      key: text,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.selectState(key, text, $event)
        }
      }
    }, [_vm._v(_vm._s(text))])
  })], 2)], 1), _vm._v(" "), _c('div', [_vm._v("操作")])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "list-wrap"
  }, [_vm._l((_vm.dataList), function(item) {
    return _c('a', {
      key: item.id,
      staticClass: "list-item",
      class: {
        highlight: _vm.high_id == item.id
      }
    }, [(_vm.keyStatus == 10) ? _c('el-checkbox', {
      attrs: {
        "label": item.id,
        "disabled": item.category_status == 10 && item.process_status == 102
      }
    }, [_vm._v(_vm._s(""))]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.user_type == 1 ? item.sub_bu_name : item.pub_bu_name) + "\n                ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.code))]), _vm._v(" "), (_vm.keyStatus == 10) ? _c('div', {
      staticClass: "item-time"
    }, [_vm._v("\n                " + _vm._s(_vm._f("justDate")(item.created_at)) + "\n                "), _c('div', {
      staticClass: "tipTime"
    }, [_vm._v("\n                    " + _vm._s(item.created_at) + "\n                ")])]) : _c('div', {
      staticClass: "item-time"
    }, [_vm._v("\n                " + _vm._s(_vm._f("justDate")(item.release_time)) + "\n                "), _c('div', {
      staticClass: "tipTime"
    }, [_vm._v("\n                    " + _vm._s(item.release_time) + "\n                ")])]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "mid"
    }, [_vm._v(_vm._s(item.task_name))])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.tpl_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.currency_amount))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.task_cycle))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.status_obj[item.process_status])), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.restDays(item))
      }
    })]), _vm._v(" "), _c('div', {
      class: {
        'orange-text': _vm.btnJudge(item)
      },
      on: {
        "click": function($event) {
          _vm.link(item.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.dealText(item)))])], 1)
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.dataList
    }
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-17fdf4d0!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/tasklistTpl.vue
// module id = 701
// module chunks = 1